import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BulkToolsRecordsState } from './bulk-tools.reducer';

export const selectDataState = createFeatureSelector<BulkToolsRecordsState>('bulkToolsRecords');

export const selectBulkData = createSelector(
    selectDataState,
    (state: BulkToolsRecordsState) => state.data
);

export const selectSingle = createSelector(
    selectDataState,
    (state: BulkToolsRecordsState) => state.singleData
);

export const selectBulkMembers = createSelector(
    selectDataState,
    (state: BulkToolsRecordsState) => state.members
);

export const selectBulkHistory = createSelector(
    selectDataState,
    (state: BulkToolsRecordsState) => state.bulkItems
);

export const selectDataLoading = createSelector(
    selectDataState,
    (state: BulkToolsRecordsState) => state.loading
);

export const selectDataError = createSelector(
    selectDataState,
    (state: BulkToolsRecordsState) => state.error
);

export const submissionSelector = createSelector(
    selectDataState,
    (state: BulkToolsRecordsState) => state.submissionCompleted
);
